import { Navigate } from "react-router-dom";
import Cookies from 'js-cookie';

export default function PublicRoute({ children }) {
  let token = Cookies.get("e_learning_token");
  return token ? <Navigate to="/dashboard" /> : children;
}
